import { type ISellAssets } from 'BreetHelpers';
import { type ReactNode, useMemo, useState } from 'react';

import { RateCalculatorContext } from './FormContext';

export const RateCalculatorProvider = ({ children }: { children?: ReactNode }) => {
	const [selectedAsset, setSelectedAsset] = useState<ISellAssets | undefined>(undefined);

	const providerValue = useMemo(
		() => ({
			setSelectedAsset,
			selectedAsset,
		}),
		[setSelectedAsset, selectedAsset]
	);

	return <RateCalculatorContext.Provider value={providerValue}>{children}</RateCalculatorContext.Provider>;
};
